export const TYPE_PROJECT_BASED = "project-based";
export const TYPE_TASK_BASED = "task-based";
export const TYPE_DAILY_PROJECT_UPDATES = "daily-project-updates";
export const TYPE_GOAL_BASED = "goal-based";
export const TYPE_REPORTS_GENERATED = "reports-generated";
export const TYPE_PASS_BASED = "pass-based";

export const CATEGORY_PRIORITY = "priority-notification";
export const CATEGORY_REVIEW_REQUESTS = "review-request-notification";
export const CATEGORY_CHANGE_REQUESTS = "change-request-notification";
export const CATEGORY_INBOX = "inbox-notification";
export const CATEGORY_UPDATES = "updates-notification";
